import get from 'lodash/get'
import store from 'store'
import moment from 'moment'
import { utils } from 'gipsy-misc'

export const getUnreadNotificationsOfTasks = (notifications, tasks) => {
  const mapTasksId = {}
  for (let task of tasks) {
    mapTasksId[task.id] = true
  }
  return (
    notifications &&
    notifications.filter(n => {
      return mapTasksId[n.taskId] && !n.read
    })
  )
}

export const getUnreadNotificationsByType = (notifications, type) => {
  if (!type) {
    return []
  }
  return notifications && notifications.filter(n => n.type === type && !n.read)
}

export const getDisplayNamesFromNotifications = notifications => {
  let displayNames = {}
  for (let notif of notifications) {
    if (notif.type !== utils.notifications.reorderTaskType) {
      continue
    }
    const creatorKey = utils.user.getKey(notif.creator)
    if (!displayNames[creatorKey]) {
      displayNames[creatorKey] = notif.creator.displayName
    }
  }
  return displayNames
}

export const getUniqueTasksIdsFromNotifications = notifications => {
  let tasksIds = new Set()
  for (let notif of notifications) {
    if (!tasksIds.has(notif.taskId)) {
      tasksIds.add(notif.taskId)
    }
  }
  return tasksIds
}

export const elementHasNotifications = (notifications, element, id) => {
  const notificationsType = getElementNotificationsType(notifications, element, id)
  return notificationsType && notificationsType.length > 0
}

export const getElementNotificationsType = (notifications, element, id) => {
  if (!notifications) {
    return null
  }
  const userId = store.getState().session.id
  let notificationsType = []
  let assignee
  for (const notification of notifications) {
    if (notification.read) {
      continue
    }
    switch (element) {
      /* sidebar: todolist tab */
      case 'todolist':
        if (userId === get(notification, 'assignee.userId')) {
          notificationsType.push(notification.type)
        }
        break

      /* sidebar: teamlist tab */
      case 'teamlist':
        if (userId !== get(notification, 'assignee.userId')) {
          notificationsType.push(notification.type)
        }
        break

      /* header: todolist + tasks */
      case 'todolist:tasks':
        if (userId === get(notification, 'assignee.userId') && !notification.completed) {
          notificationsType.push(notification.type)
        }
        break

      /* header: todolist + archive */
      case 'todolist:archive':
        if (userId === get(notification, 'assignee.userId') && notification.completed) {
          notificationsType.push(notification.type)
        }
        break

      case 'member':
        assignee = get(notification, 'assignee')
        if (id === utils.user.getKey(assignee)) {
          notificationsType.push(notification.type)
        }
        break

      case 'task':
        if (notification.taskId === id) {
          notificationsType.push(notification.type)
        }
        break

      default:
        break
    }
  }
  return notificationsType
}

export const getMostRecentNotification = notifications => {
  if (!notifications || notifications.length === 0) {
    return null
  }
  let mostRecentNotif = notifications[0]
  for (let n of notifications) {
    if (isMoreRecent(n, mostRecentNotif)) {
      mostRecentNotif = n
    }
  }
  return mostRecentNotif
}

const isMoreRecent = (n1, n2) => {
  return moment(n1.creationTime).isAfter(n2.creationTime)
}



// WEBPACK FOOTER //
// ./src/features/notifications/utils.js